import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { getColor } from "./chart-colors";

/**
 * For pie charts:
 *   spec.xAxis.key  = the field used for slice labels (e.g. "name")
 *   spec.series[0].key = the field used for slice values (e.g. "value")
 */
const ChartPie = ({ spec, data, height = 300 }) => {
    const nameKey = spec.xAxis?.key || "name";
    const valueKey = spec.series?.[0]?.key || "value";

    return (
        <ResponsiveContainer width="100%" height={height}>
            <PieChart>
                <Pie
                    data={data}
                    dataKey={valueKey}
                    nameKey={nameKey}
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    label={({ percent }) =>
                        percent > 0.04 ? `${(percent * 100).toFixed(0)}%` : ""
                    }
                >
                    {(data || []).map((entry, i) => (
                        <Cell key={entry[nameKey] ?? i} fill={getColor(i)} />
                    ))}
                </Pie>
                <Tooltip formatter={(v, name) => [v, name]} />
                <Legend />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default ChartPie;
